<template>
  <v-container>
      <v-row justify="center" alignment="center" no-gutters class="heading-row">
        <v-col cols="1" class="rays-left">
        </v-col>
        <v-col cols="8" sm="auto" class="text-white heading-block">
            <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.smAndDown}">{{this.langData.thanks.title}}</h1></div>
        </v-col>
        <v-col cols="1" class="rays-right"> 
        </v-col>
      </v-row>
      <v-row justify="center" class="text-green">
        <v-col cols="10" md="8">
          <p class="text-center"><b>{{this.langData.thanks.body}}</b></p>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-green">
        <v-col cols="auto">
          <span class="rays">
            <v-btn outlined class="pink-button submit-button" color="#e93e8f" href="https://www.arlafoods.co.uk/brands/lactofree/milk/" target="_blank">{{this.langData.thanks.cta}}</v-btn>
          </span>
        </v-col>
      </v-row>
      <v-row justify="center" alignment="center">
          <v-col cols="10" md="7" class="text-green" ref="termsClick2">
              <p class="center-text mid-size"><b v-html="this.langData.shortTerms.body"></b></p>
          </v-col>
      </v-row>
      <v-dialog
      v-model="feedbackDialog"
      max-width="460"
      overlay-color="#eae6e7"
      overlay-opacity="0.36"
      >
      <v-card color="#f0eced" >
          <v-card-text>
              <v-container>
                <v-row justify="center" alignment="center" no-gutters>
                  <v-col cols="1">
                      <v-img
                        :src="lashesLeft.src"
                        contain
                        :max-height="lashHeight"
                        class="jog-down float-right margin-sm-right"
                        :class="{'padded-top-sm': $vuetify.breakpoint.mdAndDown}"
                      ></v-img>
                  </v-col>
                  <v-col cols="9" class="text-white heading-block">
                      <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.mdAndDown}">{{heading}}</h1></div>
                  </v-col>
                  <v-col cols="1">
                      <v-img
                        :src="lashesRight.src"
                        contain
                        :max-height="lashHeight"
                        class="jog-down float-left margin-sm-left"
                        :class="{'padded-top-sm': $vuetify.breakpoint.mdAndDown}"
                      ></v-img>
                  </v-col>
              </v-row>
              <v-row justify="center" alignment="center">
                <v-col cols="auto" class="text-green">
                  <p class="text-center" v-html="introText"></p>
                  <span v-html="termsData.payload[0].contents"></span>
                </v-col>
              </v-row>
              </v-container>
          </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Terms from '../components/Terms'
export default {
  name: 'Pass',
  props: ['langData'],
  commponents: {
    Terms
  },
  mounted() {
    if(this.$refs['termsClick2'].firstChild.firstChild.childNodes[1]) {
      this.$refs['termsClick2'].firstChild.firstChild.childNodes[1].addEventListener('click', (event) => {
        this.openModalPage();
      })
    }
    if(window.location.origin == 'https://arlanl.promonow.io' || window.location.origin == 'https://staging.arlanl.promonow.io') {
      this.termsData = require('../data/terms.nl.json')
    }else{
      this.termsData = require('../data/terms.json')
    }
  },
  data: (el = this) => ({
    valid: false,
    lashesRight : {src:require('../assets/lashesRight.png')},
    lashesLeft : {src:require('../assets/lashesLeft.png')},
    lashHeight: '54px',
    heading: el.langData.terms.title,
    introText: el.langData.terms.body,
    feedbackDialog: false,
    termsData: {
      payload : [
        {
          title : "",
          body : ""
        }
      ]
    }
  }),
  methods: {
    openModalPage: function() {
      console.log(this.termsData.payload[0].contents)
      this.feedbackDialog = true
    }
  }
};
</script>
